import React, { useState } from 'react';
import { CountryConfig } from './interfaces/Config';
import { Stack } from '@fluentui/react';
import { ChevronDownRegular, ChevronUpRegular } from '@fluentui/react-icons';

interface CountryGridProps {
    countries: CountryConfig[];
    mode: string;
    title: string;
}

const CountryGrid = ({ countries, mode, title}: CountryGridProps) => {
    const [isExpanded, setIsExpanded] = useState(false)

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    const filteredCountries = mode === "selfReset" 
        ? countries.filter(country => country.SelfReset) 
        : countries;

    return (
        <div className="Container-Main">
            <div className="App">
                <header className="App-header">
                    <div className="App_body">
                        <div className={"panel_onboard"}>
                            <div onClick={toggleExpanded} style={{ cursor: 'pointer' }}>
                                <div>
                                    <h2 style={{ margin: 0 }}>
                                        {isExpanded ? <ChevronUpRegular /> : <ChevronDownRegular />}
                                        &nbsp;{title}
                                    </h2>
                                    {!isExpanded && <p style={{marginBottom: "15px"} }>(Click to expand)</p>}
                                </div>
                            </div>
                            {isExpanded && (
                                <Stack>
                                <p>Select your Country:</p>
                                <div style={styles.gridContainer}>
                                    
                                    {filteredCountries.map((country, index) => (
                                        <a
                                            key={index}
                                            href={
                                                country.AvailableLangs.length === 1
                                                    ? `${window.location.href}${country.Country}/${mode}/${country.DefaultLang}`
                                                    : `${window.location.href}${country.Country}/${mode}`
                                            }
                                            style={styles.link}
                                        >
                                            <div style={styles.countryContainer}>
                                                <img src={country.FlagUrl} alt={`${country.Country} flag`} style={styles.flag} />
                                                <p>{country.Name}</p>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                                </Stack>
                            )}
                        </div>
                    </div>
                </header>
            </div>
        </div>
    );
};

const styles = {
    gridContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '30%',
        padding: '0px 20% 0px 20%'
    } as React.CSSProperties,
    countryContainer: {
        textAlign: 'center'
    } as React.CSSProperties,
    flag: {
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        objectFit: 'cover',
        objectPosition: 'center'
    } as React.CSSProperties,
    link: {
        textDecoration: 'none',
        color: 'inherit'
    } as React.CSSProperties
};

export default CountryGrid;
